import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SmartSearchNewPropertyBasicDetailsFormModel } from '@shared-lib/models/sign-up/sign-up-smart-search/smart-search-dialog-basic-details-form.model';

export const propertyPriceValidator =
  (): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup<SmartSearchNewPropertyBasicDetailsFormModel>;
    const propertyPrice = formGroup.controls.propertyPrice;
    const deposit = formGroup.controls.deposit;
    const minPropertyPrice = Math.max(deposit.value, 10000);

    if (propertyPrice.value) {
      propertyPrice.setValidators([Validators.required, Validators.min(minPropertyPrice), Validators.max(10000000)]);

      propertyPrice.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      if (propertyPrice.value / deposit.value <= 1) {
        formGroup.setErrors({ ltvTooHigh: true });
      }
    }
    return null;
  };
